module.exports = __webpack_public_path__ + "static/img/footer.213fa22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/regioner/SE2321000016/footer.svg
// module id = CE4i
// module chunks = 1